<div class="modal import-block">
    <h4>Select Top Values for {{columnName}}</h4>
    <div *ngIf="showHint" class="hint-block mt-24">
        <div class="wrap-text">
            <p class="body-2">
                Click on the column headers to sort the Ship To Name unique values, and use the visual signals to guide your selection:
            </p>
            <ul class="body-2 hint-list">
                <li>Default Relevance sort: highlights values AI recommends to retain, based on combined impact across metrics</li>
                <li>Complexity in deep red: highlights values that add significant complexity, and are strong candidates for removal</li>
                <li>Size in deep green: highlights values with large absolute Gross Booking Value</li>
                <li>Variance in deep green: highlights values with large variance in Gross Booking Value</li>
            </ul>
        </div>
        <a (click)="showHint=false" class="btn-close material-icons-outlined">close</a>
    </div>
    <div [ngClass]="{'loading': loading}" class="wrap-top-values-table">
        <div class="block-arrow">
            <div class="cell">
                <span class="subtitle-2">Select from top</span>
            </div>
            <div *ngFor="let topN of topNOptions; let last = last" class="cell border-right-divider" [ngClass]="{'border-right-divider__arrow': last}">
                <button (click)="selectTopN(topN)" (mousedown)="$event.preventDefault()" tabindex="-1" class="btn btn-text btn-small">Top {{topN}}</button>
            </div>
        </div>
        <div class="table-top-values table-container column-border small-cell">
            <!-- Header row -->
            <div class="row header">
                <div class="cell">
                    <label class="custom-checkbox master is-check" [ngClass]="{'is-all': allSelected, 'is-some': someSelected}">
                        <input type="checkbox" [checked]="allSelected" (click)="$event.preventDefault(); toggleMasterCheckbox()" />
                        <span></span>
                    </label>
                </div>
                <div (click)="sort(TopValsSort.Value)" class="cell">
                    <div class="subtitle-2">{{columnName}}</div>
                    <span class="body-2">{{selectedCount}} selected</span>
                </div>
                <div (click)="sort(TopValsSort.Relevance)" class="cell"><span class="subtitle-2">Relevance</span></div>
                <div (click)="sort(TopValsSort.Complexity)" class="cell"><span class="subtitle-2">Complexity</span></div>
                <div (click)="sort(TopValsSort.Outcomes)" class="cell"><span class="subtitle-2">Size</span></div>
                <div (click)="sort(TopValsSort.Variance)" class="cell"><span class="subtitle-2">Variance</span></div>
            </div>

            <!-- Data rows -->
            <div class="scrollable">
                <div *ngFor="let val of values; let i = index" class="row">
                    <div class="cell">
                        <label class="custom-checkbox is-check">
                            <input type="checkbox" [(ngModel)]="val.selected" (ngModelChange)="onValueToggle()" />
                            <span></span>
                        </label>
                    </div>
                    <div class="cell">
                        {{val.value}}
                    </div>
                    <div class="cell text-right">
                        {{val.relevance}}
                    </div>
                    <div class="cell">
                        <div [style.background-color]="val.complexityColor" class="rectangle"></div>
                    </div>
                    <div class="cell">
                        <div [style.background-color]="val.outcomesColor" class="rectangle"></div>
                    </div>
                    <div class="cell">
                        <div [style.background-color]="val.varianceColor" class="rectangle"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="mt-24">
        <button (click)="save()" [ngClass]="{'loading-small': loading}" class="btn btn-primary mr-16">Continue</button>
        <button mat-dialog-close class="btn btn-secondary">Cancel</button>
    </div>
</div>
